export { default as useDarkMode } from './useDarkMode';
export * from './useDarkMode';
//# sourceMappingURL=index.js.map